/**
 * SWR config
 */
export var swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,

  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: function onErrorRetry(error, key, config, revalidate, _ref) {
    var _error$data$response$, _error$data$response, _config$errorRetryCou;

    var retryCount = _ref.retryCount;
    var statusCode = Number((_error$data$response$ = (_error$data$response = error.data.response) === null || _error$data$response === void 0 ? void 0 : _error$data$response.status) !== null && _error$data$response$ !== void 0 ? _error$data$response$ : 200);

    if (statusCode >= 400 && statusCode < 500) {
      return;
    }

    var rCount = retryCount !== null && retryCount !== void 0 ? retryCount : 1;

    if (rCount >= ((_config$errorRetryCou = config.errorRetryCount) !== null && _config$errorRetryCou !== void 0 ? _config$errorRetryCou : 0)) {
      return;
    }

    setTimeout(function () {
      return void revalidate({
        retryCount: rCount
      });
    }, config.errorRetryInterval);
  }
  /* eslint-enable max-params */

};